export default "__VITE_ASSET__CKPLabA3__"